(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                element.removeClass('hidden');
            };
            var setHidden = function () {
                if (!element.attr('show')) {
                    element.addClass('hidden');
                }
            };
            var defineVisibility = function (reset) {

                if (reset) {
                    setVisible();
                }
                
                Principal.hasAnyAuthority(authorities)
                    .then(function (result) {
                        if (result) {
                            element.attr('show', 'true');
                            setVisible();
                        } else {
                            setHidden();
                        }
                    });
            };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
            }
        }
    }
})();
